import {
    getAsLongDate, getAsLongDateTime, getAsShortDate, getAsShortDateTime,
} from '@commonClient2/services/ukgDateTime';
import { getAsTimeFormat } from '@commonClient2/services/ukgDateTime/ukgDateTime';
import { UkgDateFormat } from '../../Enums';

class DateFormatService {
    /**
     * @param { Date | string | null } date
     * @param { number } format
     */

    formatDateOrEmpty = (date, format) => {
        if (!date) {
            return '';
        }
        switch (format) {
            case UkgDateFormat.ShortDate:
                return getAsShortDate(date);
            case UkgDateFormat.ShortDateTime:
                return getAsShortDateTime(date);
            case UkgDateFormat.LongDate:
                return getAsLongDate(date);
            case UkgDateFormat.LongDateTime:
                return getAsLongDateTime(date);
            case UkgDateFormat.TimeFormat:
                return getAsTimeFormat(date);
            default:
                return getAsLongDateTime(date);
        }
    };

    /**
     * @param { Date | string | null } fromDate
     * @param { Date | string | null } toDate
     * @param { number } format
     */
    formatPeriod = (fromDate, toDate, format) => `${this.formatDateOrEmpty(fromDate, format)} - ${this.formatDateOrEmpty(toDate, format)}`;
}

export default (new DateFormatService());
